export const TypingLoader = () => {
    return(
        <div class="loader">
            <span></span>
            <span></span>
            <span></span>
        </div>
    )
}